import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styled';

function BasicStopsList({ stops, navigateToStop, bodyRef }) {
  return (
    <Styled.StopListBody ref={bodyRef}>
      {stops.map(stop => (
        <Styled.BasicStopRow
          key={stop.seq}
          onClick={() => navigateToStop(stop.locid)}
        >
          <Styled.StopIconColumn>
            <Styled.StopIcon />
          </Styled.StopIconColumn>
          <Styled.StopDescriptionColumn>
            {stop.desc}
          </Styled.StopDescriptionColumn>
        </Styled.BasicStopRow>
      ))}
    </Styled.StopListBody>
  );
}

BasicStopsList.propTypes = {
  /** Collection of stops for this list */
  stops: PropTypes.arrayOf(
    PropTypes.shape({
      desc: PropTypes.string,
      locid: PropTypes.number,
    })
  ).isRequired,
  /** Navigates to the associated stop view */
  navigateToStop: PropTypes.func.isRequired,
  /** Object used to create reference to the top level div of this component */
  bodyRef: PropTypes.shape({}),
};

BasicStopsList.defaultProps = {
  bodyRef: null,
};

export default BasicStopsList;
